// =============================================================================
// Sanitizer for the CMS "Meer info" text of a prize (security audit V3-08).
//
// The CMS allows simple formatting (bold, italics, lists, subheadings, links) and the server
// already sanitizes it (priority-api App\Support\SafeHtml). The shop renders it with v-html, so it
// is sanitized here once more with the same allowlist: a server bug or an old stored value can
// never put script into the webview. Links open outside the game, so the webview keeps the game.
// =============================================================================

import DOMPurify from 'dompurify'

// Mirrors App\Support\SafeHtml on the server. Change both together.
const ALLOWED_TAGS = ['div', 'p', 'br', 'strong', 'b', 'em', 'i', 'ul', 'ol', 'li', 'h2', 'h3', 'a']
const ALLOWED_ATTR = ['href']
const ALLOWED_URI_REGEXP = /^(?:https?:|mailto:)/i

let linkHookAdded = false

function addLinkHook() {
  if (linkHookAdded) return
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A') {
      node.setAttribute('target', '_blank')
      node.setAttribute('rel', 'noopener noreferrer')
    }
  })
  linkHookAdded = true
}

/** The prize info as safe HTML for v-html; '' for an empty value. */
export function safeInfoHtml(html) {
  if (html === null || html === undefined || html === '') return ''
  addLinkHook()
  return DOMPurify.sanitize(String(html), { ALLOWED_TAGS, ALLOWED_ATTR, ALLOWED_URI_REGEXP })
}
